/** Must match Cloud Functions `region` in functions/index.js. */
export const FUNCTIONS_REGION = "us-central1";
